import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/users/$userId")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/workspace/users/$userId",
      params: { userId: params.userId },
    });
  },
});
